.root {
  display: inline-block;
  width: 22px;
  height: 22px;
  color: var(--x-color-text-white);
  text-align: center;

  /* stylelint-disable selector-class-pattern -- FontAwesome global class */

  svg {
    width: 18px;
    height: 18px;
  }
  /* stylelint-enable selector-class-pattern */
}

.circle {
  border-radius: 50%;
}

.square {
  border-radius: 3px;
}
